"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceMatches = exports.EndsWith = exports.StartsWith = exports.Substring = exports.Matches = exports.LastPositionOf = exports.PositionOf = exports.Lower = exports.Upper = exports.SplitOnMatches = exports.Split = exports.Combine = exports.Concatenate = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var Concatenate = /** @class */ (function (_super) {
    __extends(Concatenate, _super);
    function Concatenate(json) {
        return _super.call(this, json) || this;
    }
    Concatenate.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args.some(function (x) { return x == null; })) {
            return null;
        }
        else {
            return args.reduce(function (x, y) { return x + y; });
        }
    };
    return Concatenate;
}(expression_1.Expression));
exports.Concatenate = Concatenate;
var Combine = /** @class */ (function (_super) {
    __extends(Combine, _super);
    function Combine(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        _this.separator = (0, builder_1.build)(json.separator);
        return _this;
    }
    Combine.prototype.exec = function (ctx) {
        var source = this.source.execute(ctx);
        var separator = this.separator != null ? this.separator.execute(ctx) : '';
        if (source == null) {
            return null;
        }
        else {
            var filteredArray = source.filter(function (x) { return x != null; });
            if (filteredArray.length === 0) {
                return null;
            }
            else {
                return filteredArray.join(separator);
            }
        }
    };
    return Combine;
}(expression_1.Expression));
exports.Combine = Combine;
var Split = /** @class */ (function (_super) {
    __extends(Split, _super);
    function Split(json) {
        var _this = _super.call(this, json) || this;
        _this.stringToSplit = (0, builder_1.build)(json.stringToSplit);
        _this.separator = (0, builder_1.build)(json.separator);
        return _this;
    }
    Split.prototype.exec = function (ctx) {
        var stringToSplit = this.stringToSplit.execute(ctx);
        var separator = this.separator.execute(ctx);
        if (stringToSplit && separator) {
            return stringToSplit.split(separator);
        }
        return stringToSplit ? [stringToSplit] : null;
    };
    return Split;
}(expression_1.Expression));
exports.Split = Split;
var SplitOnMatches = /** @class */ (function (_super) {
    __extends(SplitOnMatches, _super);
    function SplitOnMatches(json) {
        var _this = _super.call(this, json) || this;
        _this.stringToSplit = (0, builder_1.build)(json.stringToSplit);
        _this.separatorPattern = (0, builder_1.build)(json.separatorPattern);
        return _this;
    }
    SplitOnMatches.prototype.exec = function (ctx) {
        var stringToSplit = this.stringToSplit.execute(ctx);
        var separatorPattern = this.separatorPattern.execute(ctx);
        if (stringToSplit && separatorPattern) {
            return stringToSplit.split(new RegExp(separatorPattern));
        }
        return stringToSplit ? [stringToSplit] : null;
    };
    return SplitOnMatches;
}(expression_1.Expression));
exports.SplitOnMatches = SplitOnMatches;
// Length is completely handled by overloaded#Length
var Upper = /** @class */ (function (_super) {
    __extends(Upper, _super);
    function Upper(json) {
        return _super.call(this, json) || this;
    }
    Upper.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            return arg.toUpperCase();
        }
        else {
            return null;
        }
    };
    return Upper;
}(expression_1.Expression));
exports.Upper = Upper;
var Lower = /** @class */ (function (_super) {
    __extends(Lower, _super);
    function Lower(json) {
        return _super.call(this, json) || this;
    }
    Lower.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            return arg.toLowerCase();
        }
        else {
            return null;
        }
    };
    return Lower;
}(expression_1.Expression));
exports.Lower = Lower;
// Indexer is completely handled by overloaded#Indexer
var PositionOf = /** @class */ (function (_super) {
    __extends(PositionOf, _super);
    function PositionOf(json) {
        var _this = _super.call(this, json) || this;
        _this.pattern = (0, builder_1.build)(json.pattern);
        _this.string = (0, builder_1.build)(json.string);
        return _this;
    }
    PositionOf.prototype.exec = function (ctx) {
        var pattern = this.pattern.execute(ctx);
        var string = this.string.execute(ctx);
        if (pattern == null || string == null) {
            return null;
        }
        else {
            return string.indexOf(pattern);
        }
    };
    return PositionOf;
}(expression_1.Expression));
exports.PositionOf = PositionOf;
var LastPositionOf = /** @class */ (function (_super) {
    __extends(LastPositionOf, _super);
    function LastPositionOf(json) {
        var _this = _super.call(this, json) || this;
        _this.pattern = (0, builder_1.build)(json.pattern);
        _this.string = (0, builder_1.build)(json.string);
        return _this;
    }
    LastPositionOf.prototype.exec = function (ctx) {
        var pattern = this.pattern.execute(ctx);
        var string = this.string.execute(ctx);
        if (pattern == null || string == null) {
            return null;
        }
        else {
            return string.lastIndexOf(pattern);
        }
    };
    return LastPositionOf;
}(expression_1.Expression));
exports.LastPositionOf = LastPositionOf;
var Matches = /** @class */ (function (_super) {
    __extends(Matches, _super);
    function Matches(json) {
        return _super.call(this, json) || this;
    }
    Matches.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), string = _a[0], pattern = _a[1];
        if (string == null || pattern == null) {
            return null;
        }
        return new RegExp('^' + pattern + '$').test(string);
    };
    return Matches;
}(expression_1.Expression));
exports.Matches = Matches;
var Substring = /** @class */ (function (_super) {
    __extends(Substring, _super);
    function Substring(json) {
        var _this = _super.call(this, json) || this;
        _this.stringToSub = (0, builder_1.build)(json.stringToSub);
        _this.startIndex = (0, builder_1.build)(json.startIndex);
        _this.length = (0, builder_1.build)(json['length']);
        return _this;
    }
    Substring.prototype.exec = function (ctx) {
        var stringToSub = this.stringToSub.execute(ctx);
        var startIndex = this.startIndex.execute(ctx);
        var length = this.length != null ? this.length.execute(ctx) : null;
        // According to spec: If stringToSub or startIndex is null, or startIndex is out of range, the result is null.
        if (stringToSub == null ||
            startIndex == null ||
            startIndex < 0 ||
            startIndex >= stringToSub.length) {
            return null;
        }
        else if (length != null) {
            return stringToSub.substr(startIndex, length);
        }
        else {
            return stringToSub.substr(startIndex);
        }
    };
    return Substring;
}(expression_1.Expression));
exports.Substring = Substring;
var StartsWith = /** @class */ (function (_super) {
    __extends(StartsWith, _super);
    function StartsWith(json) {
        return _super.call(this, json) || this;
    }
    StartsWith.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args.some(function (x) { return x == null; })) {
            return null;
        }
        else {
            return args[0].slice(0, args[1].length) === args[1];
        }
    };
    return StartsWith;
}(expression_1.Expression));
exports.StartsWith = StartsWith;
var EndsWith = /** @class */ (function (_super) {
    __extends(EndsWith, _super);
    function EndsWith(json) {
        return _super.call(this, json) || this;
    }
    EndsWith.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args.some(function (x) { return x == null; })) {
            return null;
        }
        else {
            return args[1] === '' || args[0].slice(-args[1].length) === args[1];
        }
    };
    return EndsWith;
}(expression_1.Expression));
exports.EndsWith = EndsWith;
var ReplaceMatches = /** @class */ (function (_super) {
    __extends(ReplaceMatches, _super);
    function ReplaceMatches(json) {
        return _super.call(this, json) || this;
    }
    ReplaceMatches.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args.some(function (x) { return x == null; })) {
            return null;
        }
        else {
            return args[0].replace(new RegExp(args[1], 'g'), args[2]);
        }
    };
    return ReplaceMatches;
}(expression_1.Expression));
exports.ReplaceMatches = ReplaceMatches;
//# sourceMappingURL=string.js.map